import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — auto-fermeture d'un toast après un délai.
 * Spec : docs/design-system/REFERENCE.md §4
 */
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  connect() {
    this.timer = setTimeout(() => this.element.remove(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
